import React, { useState } from 'react';
import classNames from '../../classnames.js';
import modules_e00953a9 from './icon.module.scss.js';

const Icon = (props) => {
    const { className, children, width, height, parentRef, dataTestId, loading } = props;
    const [iconPath, setIconPath] = useState(null);
    const updateSvgHandler = (colorSvg, childrenObject) => {
        const result = React.Children.map(childrenObject, (child) => {
            if (React.isValidElement(child) && (child.type === "path" || child.type === "circle" || child.type === "mask")) {
                const originalProps = child.props || {};
                let updatedProps = {
                    ...originalProps,
                    stroke: colorSvg
                };
                if (originalProps && originalProps.fill) {
                    updatedProps = { ...updatedProps, fill: colorSvg };
                }
                return React.cloneElement(child, updatedProps);
            }
            return child;
        });
        setIconPath(result);
    };
    const updateSvg = (colorSvg) => {
        const result = React.Children.map(children, (child) => {
            if (React.isValidElement(child) && child.type === "svg") {
                return child.props.children;
            }
            return child;
        });
        updateSvgHandler(colorSvg, result);
    };
    const getParentTextColor = () => {
        let textColor = null;
        if (parentRef?.current) {
            const computedStyle = window.getComputedStyle(parentRef.current);
            textColor = computedStyle.getPropertyValue("color");
        }
        return textColor;
    };
    const getIconColorByClassName = () => {
        let iconColor = null;
        if (className) {
            const elements = document.getElementsByClassName(className);
            for (let i = 0; i < elements.length; i++) {
                iconColor = window.getComputedStyle(elements[i], null).getPropertyValue("color");
            }
        }
        return iconColor;
    };
    React.useEffect(() => {
        if (parentRef?.current) {
            const textColor = getParentTextColor();
            updateSvg(textColor);
        }
        if (parentRef?.current?.disabled) {
            updateSvg("#ffffff");
        }
        if (className) {
            const iconColor = getIconColorByClassName();
            updateSvg(iconColor);
        }
    }, [parentRef, className]);
    React.useEffect(() => {
        const handleMouseOver = () => {
            if (parentRef?.current) {
                const hoverColor = getParentTextColor();
                updateSvg(hoverColor);
            }
        };
        const handleMouseLeave = () => {
            const prevColor = getIconColorByClassName() || getParentTextColor();
            updateSvg(prevColor || "#121212");
        };
        if (parentRef?.current && !parentRef.current.disabled) {
            parentRef.current.addEventListener("mouseover", handleMouseOver);
            parentRef.current.addEventListener("mouseleave", handleMouseLeave);
        }
        return () => {
            if (parentRef?.current && !parentRef.current.disabled) {
                parentRef.current.removeEventListener("mouseover", handleMouseOver);
                parentRef.current.removeEventListener("mouseleave", handleMouseLeave);
            }
        };
    }, [parentRef]);
    const getViewBox = () => {
        if (React.isValidElement(children) && children.type === "svg" && children.props.viewBox) {
            return children.props.viewBox;
        }
        return "0 0 24 24";
    };
    const getSvgClassName = () => classNames(modules_e00953a9.icon, className, { [modules_e00953a9.skeleton]: loading });
    const getSvgWidth = () => {
        let w = "25";
        if (className) {
            const elements = document.getElementsByClassName(className);
            for (let i = 0; i < elements.length; i++) {
                const style = window.getComputedStyle(elements[i], null);
                w = style.width;
            }
        }
        if (width)
            w = width;
        return w;
    };
    const getSvgHeight = () => {
        let h = "25";
        if (className) {
            const elements = document.getElementsByClassName(className);
            for (let i = 0; i < elements.length; i++) {
                const style = window.getComputedStyle(elements[i], null);
                h = style.height;
            }
        }
        if (height)
            h = height;
        return h;
    };
    const renderIcon = () => (React.createElement("div", { className: getSvgClassName(), "data-testid": dataTestId },
        React.createElement("svg", { width: getSvgWidth(), height: getSvgHeight(), 
            // fill="#FFFFFF"
            fill: 'transparent', viewBox: getViewBox(), xmlns: "http://www.w3.org/2000/svg" }, iconPath || children)));
    return renderIcon();
};

export { Icon as default };
//# sourceMappingURL=icon.js.map
